import styled from 'styled-components';

export const Notification = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 12px;
    height: 30px;
    color: #aaa;
`;